module.exports = __webpack_public_path__ + "static/notification_sound-191725d810062bcc96d0c79aa7d5aaa5.mp3";